<div class="mt-3" *ngIf="visible">
  <form-workflow
    [form]="form"
    [sectionNumber]="5"
    [leftConfigs]="[111]"
    [rightConfigs]="[112]"
    [service]="service"
  >
  </form-workflow>
</div>
